module.exports = __webpack_public_path__ + "media/time-9fa2e0e6.png";